var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"09311ab5bb78abc8e4b368ec00302df864b87f56"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["propup@propup-gmbh"]={id:"09311ab5bb78abc8e4b368ec00302df864b87f56"};
      